<template>
  <div
    class="__dropdown __dropdown-wrapper"
  >
    <input
      id="menu"
      type="checkbox"
      :checked="showDropdown"
      :disabled="disabled"
      @change="toggleDropdown"
    >
    <label
      for="menu"
      class="btn btn-outline-dark btn-sm __dropdown-label"
      :class="disabled ? 'disabled' : ''"
    >
      <slot name="button-content">
        <GjIcon
          name="Filters"
          class="mr-50"
        />
        {{ title }}
      </slot>
    </label>
    <div
      v-if="showDropdown"
      class="__dropdown-menu"
    >
      <slot name="menu-items" />
    </div>
  </div>
</template>

<script>
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'

export default {
  components: {
    GjIcon,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    showDropdown: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
    },
  },
  methods: {
    toggleDropdown() {
      this.$emit('change')
    },
  },
}
</script>

<style lang="scss">

input[type="checkbox"]#menu {
    display: none;
}

.__dropdown-menu, .__dropdown-submenu ul, div.__dropdown-submenu input[type="radio"] {
    display: none;
}
#menu:checked ~ .__dropdown-menu, .__dropdown-submenu input:checked ~ ul {
    display: block;
}

div.__dropdown-menu {
  background-color: #ffffff;
  border-radius: 0.358rem;
  padding: 8px;
  width: 220px;
  margin: 0;
  font-weight: 400;
  transition: all 0.3s;
  border: 1px solid rgba(44, 44, 44, 0.05);
  background-clip: padding-box;
  position: absolute;
  right: 0;
  z-index: 99;
  box-shadow: -2px 2px 67px -40px rgba(0,0,0,0.75);
}
.__dropdown-label {
  background-color: #ffffff;
}
div.__dropdown{
  position: relative;
  display: inline-block;
}
.drodown-wrapper .disabled {
  border-color: #e0e5eb;
}
</style>
